import React, { useEffect, useState } from 'react';
import { clampEditorFontSizePx, editorFontSizeCss } from '../../utils/editorTypography';

export default function RichTextFontSizePopover({
  open,
  anchorRect,
  initialPx,
  onApply,
  onClose,
}) {
  const [px, setPx] = useState(clampEditorFontSizePx(initialPx ?? 16));

  useEffect(() => {
    if (open) setPx(clampEditorFontSizePx(initialPx ?? 16));
  }, [open, initialPx]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open || !anchorRect) return null;

  const style = {
    position: 'fixed',
    top: Math.min(anchorRect.bottom + 6, window.innerHeight - 120),
    left: Math.min(anchorRect.left, window.innerWidth - 220),
    zIndex: 10050,
  };

  return (
    <>
      <button
        type="button"
        className="fixed inset-0 z-[10049] cursor-default bg-transparent border-0 p-0"
        aria-label="Fermer"
        onClick={onClose}
      />
      <div
        className="w-[200px] rounded-lg border border-border bg-popover text-popover-foreground shadow-lg p-3 space-y-3"
        style={style}
        role="dialog"
        aria-label="Taille de police"
      >
        <p className="text-xs font-semibold text-foreground">Taille (px)</p>
        <input
          type="number"
          min={6}
          max={200}
          className="w-full rounded-md border border-input bg-background px-2 py-1.5 text-sm tabular-nums"
          value={px}
          onChange={(e) => setPx(clampEditorFontSizePx(e.target.value))}
        />
        <div className="flex justify-end gap-2">
          <button
            type="button"
            className="text-xs text-muted-foreground hover:text-foreground px-2 py-1 rounded-md hover:bg-muted"
            onClick={() => {
              onApply?.(false);
              onClose?.();
            }}
          >
            Par défaut
          </button>
          <button
            type="button"
            className="text-xs font-medium bg-primary text-primary-foreground px-3 py-1.5 rounded-md hover:opacity-90"
            onClick={() => {
              onApply?.(editorFontSizeCss(px));
              onClose?.();
            }}
          >
            Appliquer
          </button>
        </div>
      </div>
    </>
  );
}
